const SDK_VERSION = "10.70.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
